interface ColorInputProps {
  label: string;
  value: string;
  defaultValue: string;
  templateDefault: string;
  onChange: (value: string) => void;
}

export default function ColorInput({
  label,
  value,
  templateDefault,
  onChange,
}: ColorInputProps) {
  const displayColor = value || templateDefault;
  const isDefault = !value;

  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const handleHexChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const hex = e.target.value;
    onChange(hex);
  };

  const handleReset = () => {
    onChange('');
  };

  return (
    <div className="color-field">
      <label className="color-field-label">{label}</label>
      <div className="color-field-row">
        <input
          type="color"
          className="color-field-picker"
          value={displayColor}
          onChange={handleColorChange}
        />
        <input
          type="text"
          className="color-field-hex"
          value={value}
          placeholder={templateDefault}
          onChange={handleHexChange}
          maxLength={7}
        />
        <div
          className={`color-field-swatch ${isDefault ? 'is-default' : ''}`}
          style={{ backgroundColor: displayColor }}
        />
        {!isDefault && (
          <button
            type="button"
            className="color-field-reset"
            onClick={handleReset}
          >
            Reset
          </button>
        )}
      </div>
      <span className="color-field-default">
        Template default: {templateDefault}
      </span>
    </div>
  );
}
